let language = {
    BUILDER_PREVIEW_NOT_SUPPORTED_UNCUSTOMIZED_PRODUCTS_ALERT_TITLE: "当前不支持",
    BUILDER_PREVIEW_NOT_SUPPORTED_UNCUSTOMIZED_PRODUCTS_ALERT_CONTENT: "未定制的产品暂时不支持预览。",
    BUILDER_PREVIEW: "预览"
};

export { language }
